import React from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core';
import { ReactNode } from 'react';
import {Alert, Color} from "@material-ui/lab";

export type UIDialogProps = {
    open: boolean;
    onClose: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
    title?: ReactNode | string;
    actions?: ReactNode[];
    children: ReactNode;
    disableEscapeKeyDown?: boolean;
    alert?: { severity: Color; message: string; };
};

export const UIDialog = ({
    onClose,
    open,
    title,
    actions,
    children,
    disableEscapeKeyDown = false,
    alert
}: UIDialogProps) => {

    const handleOnClose = () => {
        onClose({}, 'backdropClick');
    };

    return (
        <Dialog
            disableEscapeKeyDown={disableEscapeKeyDown}
            open={open}
            onClose={handleOnClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {!!title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
            {!!alert && <Alert severity={alert.severity}>{alert.message}</Alert>}
            <DialogContent>{children}</DialogContent>
            <DialogActions>{actions}</DialogActions>
        </Dialog>
    );
};
